import './Circular.9bf446f178fbfb321cc5f896dd2cf4fc.css';
export default {"circular":"_circular_3c2bc_1","centered":"_centered_3c2bc_1","small":"_small_3c2bc_1","medium":"_medium_3c2bc_1","large":"_large_3c2bc_1"};